import React, { useEffect } from "react";
import {
  changeBookingStatusService,
  handleCheckBookingStatusService,
} from "../../services/AuthenticationServices";
import { toastError } from "../../../../components/Toast";
import { DASHBOARD_DESKIMO_LINK } from "../../../App/configs/ListRoutes";
import { useNavigate, useParams } from "react-router-dom";
import { useQuery } from "../../../../utils/custom-hooks";
import { SWAL_CONFIRM_OPTION } from "../../../../components/SweetAlert/configs/SwalConfigs";
import { SweetAlertCommon } from "../../../../components/SweetAlert";
import { PUBLIC_URL } from "../../../App/configs/Constants";
import LoginTemplate from "../../../App/views/LoginTemplate";
import ButtonCustom from "../../../../components/Button";
import { useDispatch } from "react-redux";
import { isGlobalIndicatorAction } from "../../../App/actions/AppActions";

const BookingCancelRequest = () => {
  const { token } = useParams();
  const queryParams = useQuery();
  const navigate = useNavigate();

  const dispatch = useDispatch();

  useEffect(() => {
    (async () => {
      await handleCheckBookingStatusService(
        queryParams.get("type"),
        token,
        navigate
      );
    })();
  }, []);

  const _handleSave = async () => {
    try {
      const type = queryParams.get("type");

      if (!type || !token) {
        return;
      }
      dispatch(isGlobalIndicatorAction(true));

      await changeBookingStatusService(type, token);

      const iconHtml = (
        <img src={PUBLIC_URL + "/assets/icons/icon-check-green.svg"} />
      );

      const options = SWAL_CONFIRM_OPTION({
        iconHtml,
        title: "Approve Cancellation Request Successfully!",
        confirmText: "OK",
      });
      SweetAlertCommon({
        options: { ...options, allowOutsideClick: false },
        confirmCallback: () => navigate(DASHBOARD_DESKIMO_LINK),
      });
    } catch (e: any) {
      toastError(e?.status?.message);
    } finally {
      dispatch(isGlobalIndicatorAction(false));
    }
  };

  const _handleClick = () => {
    const options = SWAL_CONFIRM_OPTION({
      title: "Are you sure want to approve cancellation?",
      showCancelButton: true,
      confirmText: "OK",
    });
    SweetAlertCommon({
      options: { ...options, allowOutsideClick: false },
      confirmCallback: _handleSave,
    });
  };

  return (
    <LoginTemplate>
      <div className={"login__title"}>
        {"Cancellation of the booking request"}
      </div>
      <div className={"login__sub_title"}>
        Please confirm if you would like to approve the cancellation of this
        booking request.
      </div>
      <hr className={"form-decline-hr"} />
      <ButtonCustom
        className={"primary"}
        height={"47px"}
        onClick={_handleClick}
        width={"100%"}
      >
        Yes, approve cancellation
      </ButtonCustom>
    </LoginTemplate>
  );
};

export default BookingCancelRequest;
